import React from 'react';
import axios from '../res/axios';
import { bindActionCreators } from 'redux';
import * as actionCreators from '../res/actions';
import { connect } from 'react-redux';
import {
  Button,
  Table,
  TableFiltering,
  TablePagination,
  TableSorting,
  TableWrapLines,
  TablePreferences,
  Icon,
  ExpandableSection,
  Modal,
  Spinner,
  ColumnLayout
} from '@amzn/awsui-components-react/polaris';
import jwtDecode from 'jwt-decode';


const mapStateToProps = (state) => {
  return { }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ 
    addNotification: actionCreators.addNotification,
  },dispatch);
}

function getRandomInt(max=100) {
  return Math.floor(Math.random() * Math.floor(max));
}

const FILTERING_FIELDS = [
  "challengeId",
  "attemptId",
  "attemptStatus"
];

const SORTABLE_COLUMNS = [
  {id: 'challengeId', field: 'challengeId'},
  {id: 'attemptId', field: 'attemptId'},
  {id: 'attemptStatus', field: 'status'}
];

class Header extends React.Component{

  render(){
    return(
      <div className='awsui-util-action-stripe'>
        <div className='awsui-util-action-stripe-title'>
          <h2>My challenges&nbsp;
            {this.props.counter ? <span className='custom-action-stripe-counter'>{this.props.counter}</span> : ''}
          </h2>
        </div>
        
      </div>
    );
  }
}

const getAlias = () => {
  try {
      const token = localStorage.getItem('BOTSE_SESSION_TOKEN');
      return jwtDecode(token).sub;
  }
  catch(err){
      console.log("Critical: Token not found.", err);
  }
}

class MyDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      challenges: [],
      attempts: [],
      pagesCount: 1,
      currentPageIndex: 1,
      filteringText: '',
      sortingDescending: false,
      pageSize: 10,
      loading: true,
      filteringDisabled: false,
      modalVisible: false,
      modalLoading: true,
      selectedChallenge: '',
      lastEvaluatedKey: ''
    };
    this.loadItems = this.loadItems.bind(this);
    this.getColumnDefinition = this.getColumnDefinition.bind(this)
    this.renderItem = this.renderItem.bind(this);
  }

  componentDidMount() {
    this.loadItems();
  }
  componentDidUpdate(prevProps) {
    //   if(this.props.domainId !== prevProps.domainId) {
    //       this.loadItems();
    //   }
  }
  getColumnDefinition(){
      return [{
        id: 'challengeId',
        header: () => 'Challenge ID',
        cell: challenge => <div><a onClick={this.buttonclick.bind(this, challenge.challengeId)} href='#/'>{challenge.challengeId}</a></div>,
        minWidth: '120px',
        allowLineWrap: true
      }, 
      {
        id: 'attemptId',
        header: () => 'Attempt Id',
        cell: challenge => `${challenge.attemptId}`,
        minWidth: '110px',
        allowLineWrap: true
      },
      {
        id: 'status',
        header: () => 'Status',
        cell: item => {
          let statusClass, iconClass, statusText;
          if(item.attemptStatus === "PROVISION_IN_PROGRESS") {
              statusClass = "awsui-util-status-info";
              iconClass = "status-pending";
              statusText = "Provisioning";
          }
          else if(item.attemptStatus === "PROVISION_COMPLETE") {
              statusClass = "awsui-util-status-info";
              iconClass = "status-stopped";
              statusText = "Provision Complete";
          }
          else if(item.attemptStatus === "PROVISION_FAILED" || item.attemptStatus === "VALIDATION_FAILED") {
              statusClass = "awsui-util-status-negative";
              iconClass = "status-negative";
              statusText = "Terminated";
          }
          else if(item.attemptStatus === "ATTEMPT_IN_PROGRESS") {
              statusClass = "awsui-util-status-info";
              iconClass = "status-in-progress";
              statusText = "Ongoing";
          }
          else if(item.attemptStatus === "VALIDATION_IN_PROGRESS") {
              statusClass = "awsui-util-status-info";
              iconClass = "status-pending";
              statusText = "Validating";
          }
          else {
              if(item.score !== undefined && item.score !== null){
                  statusClass = "awsui-util-status-positive";
                  iconClass = "status-positive";
                  statusText = "Complete";
              }
              else {
                  statusClass = "awsui-util-status-negative";
                  iconClass = "status-negative";
                  statusText = "Terminated";
              }
          }
          return (
              <div className={statusClass}>
                  <Icon name={iconClass}/>
                  <span> {statusText}</span>
              </div>
          )
        },
        minWidth: '100px',
        allowLineWrap: true
      },
      {
        id: 'score',
        header: () => 'Score',
        cell: challenge => {
            return (<ExpandableSection
              header={`${challenge.score !== undefined ? JSON.stringify(parseInt(challenge.score.totalScore,10)) : "N/A"}`}
              content={`${challenge.score !== undefined ? JSON.stringify(challenge.score.splitScore) : "N/A"}`}
              variant="navigation"
            ></ExpandableSection>);
          },
        minWidth: '110px',
        allowLineWrap: true
      },
      {
        id: 'Result',
        header: () => 'Result',
        cell : item => {
            if (item.score === undefined || item.score.passed === undefined) {
                return (
                    <span>{'-'}</span>
                )
            }
            else {
                if (item.score.passed === "true") {
                    return (
                        <div className={"awsui-util-status-positive"}>
                            <Icon name={"status-positive"}/>
                            <span> {"Passed"}</span>
                        </div>
                    )
                }
                else {
                    return (
                        <div className={"awsui-util-status-negative"}>
                            <Icon name={"status-negative"}/>
                            <span> {"Failed"}</span>
                        </div>
                    )
                }
            }
        }
      },
      {
        id: 'createdAt',
        header: () => 'Start Time',
        cell: challenge => {return new Date(parseInt(challenge.createdAt, 10)).toISOString()},
        minWidth: '110px',
        allowLineWrap: true
      }
    ];
  }

  buttonclick(challengeId){
    this.setState({
      selectedChallenge: challengeId,
      modalVisible: true,
      modalLoading: true
    });
    let headers = {
        'x-csrf-token': localStorage.getItem('BOTSE_SESSION_TOKEN'),
        'Action': 'Attempt:DescribeChallenge'
    };
    let params = {
        challengeId: challengeId
    };
    axios.get("action", {headers: headers, params: params})
    .then(res => {
        console.log(res);
        res.data = JSON.parse(res.data);
        console.log(res.data.data);
        const errorCode = res.data.error.code ? res.data.error.code : null;
        if (errorCode === "403") {
          this.setState({
            modalLoading: false,
            challenges: []
          });
          var notification = {
            id : getRandomInt(),
            type: "error",
            dismissible: true,
            autoHide: true,
            header: "Failed to fetch challenge details!",
            content: "You do not have permissions to view challenges under this domain",
          };
          this.props.addNotification(notification);
        }
        else if (errorCode === null){
          const challenges = res.data.data.challenges;
          this.setState({
            modalLoading: false,
            challenges: challenges
          });
        }
        else {
          this.setState({
            modalLoading: false,
            challenges: []
          });
          var notice = {
            id : getRandomInt(),
            type: "error",
            dismissible: true,
            autoHide: true,
            header: "Failed to fetch challenge details!",
            content: "There was some unexpected error to load the challenges. Please check your internet connection and if the issue persists, please contact the bottlenose team",
          };
          this.props.addNotification(notice);
        }
    })
    .catch((err) => {
      console.log(JSON.stringify(err));
      this.setState({
        modalLoading: false,
        challenges: []
      });
      var notification = {
        id : getRandomInt(),
        type: "error",
        dismissible: true,
        autoHide: true,
        header: "Failed to fetch challenge details!",
        content: "Please check your internet connectivity and reload the page.",
      };
      this.props.addNotification(notification);
    });
  }

  loadItems(lastEvaluatedKey = '') {
    // window.fetchItems(this.state, ({ items, pagesCount, currentPageIndex }) => this.setState({
    //   distributions: items,
    //   pagesCount,
    //   currentPageIndex,
    //   loading: false,
    //   filteringDisabled: false
    // }));
    this.setState({
            loading: true
    });
    let headers = {
        'x-csrf-token': localStorage.getItem('BOTSE_SESSION_TOKEN'),
        'Action': 'Attempt:ListAttempts'
    };
    let params = lastEvaluatedKey === '' ? {
        userId: getAlias()
    } : {
      userId: getAlias(),
      LastEvaluatedKey: lastEvaluatedKey
    };
    axios.get("action", {headers: headers, params: params})
    .then(res => {
        console.log(res);
        res.data = JSON.parse(res.data);
        console.log(res.data.data);
        const errorCode = res.data.error.code ? res.data.error.code : null;
        if (errorCode === "403") {
          this.setState({
            loading: false,
            attempts: []
          });
          var notification = {
            id : getRandomInt(),
            type: "error",
            dismissible: true,
            autoHide: true,
            header: "Failed to fetch attempts!",
            content: "There was some unexpected error to load the attempts. Please check your internet connection and if the issue persists, please contact the Bottlenose team",
          };
          this.props.addNotification(notification);
        }
        else if (errorCode === null){
          let challengesList = this.state.attempts.map(item => {
            return item.challengeId
          });
          let newAttempts = res.data.data.attempts.filter(item => !(challengesList.includes(item.challengeId)));
          let attempts = [...this.state.attempts, ...newAttempts];
          const lastEvaluatedKey = 'LastEvaluatedKey' in res.data.data ? res.data.data.LastEvaluatedKey : '';
          this.setState({
            loading: false,
            attempts: attempts,
            lastEvaluatedKey
          });
        }
        else {
          this.setState({
            loading: false,
            attempts: []
          });
          var notice = {
            id : getRandomInt(),
            type: "error",
            dismissible: true,
            autoHide: true,
            header: "Failed to fetch attempts!",
            content: "There was some unexpected error to load the attempts. Please check your internet connection and if the issue persists, please contact the Bottlenose team",
          };
          this.props.addNotification(notice);
        }
    })
    .catch((err) => {
      console.log(err);
      this.setState({
        loading: false,
        attempts: []
      });
      var notification = {
        id : getRandomInt(),
        type: "error",
        dismissible: true,
        autoHide: true,
        header: "Failed to fetch attempts!",
        content: "Please check your internet connectivity and reload the page.",
      };
      this.props.addNotification(notification);
    });
  }

  onPaginationChange(evt) {
    this.setState({
      pageSize: evt.detail.pageSize,
      currentPageIndex: evt.detail.currentPageIndex
    });
  }

  onSortingChange(evt) {
    this.setState({
      sortingColumn: evt.detail.sortingColumn,
      sortingDescending: evt.detail.sortingDescending
    });
  }

  onFilteringChange(evt) {
    this.setState({
      filteringText: evt.detail.filteringText
    });
  }

  onNextPageClick(evt) {
    if (!evt.detail.requestedPageAvailable){
      this.loadItems(this.state.lastEvaluatedKey);
    }
  }

  clearFilter() {
    this.setState({
      filteringText: ''
    });
  }

  modalVisibleToggle() {
    this.setState({
      modalVisible: false
    })
  }

 renderItem(title, value, key) {
    return (
        <div key={key}>
            <div className="awsui-util-label">{title}</div>
            <div className="content-nullable">
                {value}
            </div>
        </div>
    );
}

  render() {
    let challengesLink = ''
    if (this.state.modalVisible && this.state.challenges[0] && this.state.challenges[0].domainId){
      let domainId = this.state.challenges[0].domainId.includes(',') ?  this.state.challenges[0].domainId.split(',')[0] : this.state.challenges[0].domainId;
      challengesLink = `${window.location.origin}/${domainId}/${this.state.challenges[0].challengeId}`;
    }
    return (
      <div>
        <div id='challenge_table_container'>
          <Table
            columnDefinitions={this.getColumnDefinition(this.props.location.pathname)}
            items={this.state.attempts}
            header={(
              <Header />
            )}
            loading={this.state.loading}
            empty={
              <div className="awsui-util-t-c">
                <div className="awsui-util-pt-xs awsui-util-mb-xs">
                  <b>No attempts found</b>
                </div>
              </div>
            }
            noMatch={
              <div className="awsui-util-t-c">
                <div className="awsui-util-pt-xs awsui-util-mb-xs">
                  <b>No attempts found</b>
                </div>
                <p className="awsui-util-mb-s">No results match your query</p>
                <div className="awsui-util-mb-l">
                  <Button onClick={this.clearFilter.bind(this)} text="Clear filter"/>
                </div>
              </div>
            }
          >
            <TableFiltering
              filteringPlaceholder='Search challenges'
              filteringFields={FILTERING_FIELDS}
              onFilteringChange={this.onFilteringChange.bind(this)}
              disabled={this.state.filteringDisabled}
              filteringText={this.state.filteringText}
            />
            <TablePagination
              openEnd={!(this.state.lastEvaluatedKey === '')}
              currentPageIndex={this.state.currentPageIndex}
              pageSize={this.state.pageSize}
              onPaginationChange={this.onPaginationChange.bind(this)}
              disabled={this.state.loading}
              onNextPageClick={this.onNextPageClick.bind(this)}
            />
            <TableSorting
              sortingColumn={this.state.sortingColumn}
              sortableColumns={SORTABLE_COLUMNS}
              disabled={this.state.loading}
              onSortingChange={this.onSortingChange.bind(this)}
            />
            <TablePreferences
              title='Preferences'
              confirmLabel='Confirm'
              cancelLabel='Cancel'
              disabled={this.state.loading}
            >
              <TableWrapLines
                label='Wrap lines'
                description='Check to see all the text and wrap the lines'
                value={false}
              />
            </TablePreferences>
          </Table>
        </div>
        <div>
          <Modal
            visible={this.state.modalVisible}
            header={`Challenge Details : ${this.state.selectedChallenge}`}
            onDismiss={this.modalVisibleToggle.bind(this)}
            >
          {this.state.modalLoading ? <Spinner /> : 
            <div>
              <ColumnLayout columns={1} borders="vertical">
                <div data-awsui-column-layout-root="true">
                    {this.renderItem('Name', this.state.challenges[0].name)}
                </div>
            </ColumnLayout>
            <ColumnLayout columns={2} borders="vertical">
                <div data-awsui-column-layout-root="true">
                    {this.renderItem('Type', this.state.challenges[0].type ? this.state.challenges[0].type : '-')}
                    {this.renderItem('Primary Owner', <a href={'https://phonetool.amazon.com/users/' + this.state.challenges[0].primaryOwner} target = {'_blank'}> {this.state.challenges[0].primaryOwner}</a>)}
                </div>
            </ColumnLayout>
            <br />
            <a href={challengesLink} target={'_blank'}>More Details <Icon name='external'></Icon></a>
            </div>
          }
          </Modal>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MyDashboard);



// WEBPACK FOOTER //
// ./src/app/components/ChallengesTable.jsx



// WEBPACK FOOTER //
// ./src/app/components/MyDashboard.jsx